import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { clsx } from 'clsx';
import React from 'react';
import { Checkbox as Checkbox$1 } from 'react-aria-components';

const root = "_root_s8mp0_1";
const checkbox = "_checkbox_s8mp0_13";
const label = "_label_s8mp0_57";
const styles = {
	root: root,
	checkbox: checkbox,
	label: label
};

const Checkbox = (_a) => {
  var { children, className, validationBehavior = "native" } = _a, props = __rest(_a, ["children", "className", "validationBehavior"]);
  return React.createElement(Checkbox$1, Object.assign({ className: clsx(className, styles.root), "data-zds": true, validationBehavior, "data-has-no-visible-label": React.Children.count(children) === 0 ? true : void 0 }, props), ({ isIndeterminate, isSelected }) => React.createElement(
    React.Fragment,
    null,
    React.createElement(
      "div",
      { className: styles.checkbox, "data-zds": true },
      React.createElement("svg", { viewBox: "0 0 18 18", "aria-hidden": "true", "data-zds": true }, isIndeterminate ? React.createElement("rect", { x: 0, y: 7, width: 18, height: 4 }) : isSelected && React.createElement("polyline", { points: "2 9 8 14 16 4" }))
    ),
    React.createElement("div", { className: styles.label }, children)
  ));
};

export { Checkbox };
//# sourceMappingURL=Checkbox.es.js.map
